import React, { useEffect } from 'react';
import { NULL_VALUE_TITLE } from './constants';

export const Legends = ({ titleColorsMap, onSelectionChange }) => {
  const [selectedLegends, setSelectedLegends] = React.useState({});

  useEffect(() => {
    const tempSelection = {};
    Object.keys(titleColorsMap).forEach((category) => {
      tempSelection[category] = true;
    });
    setSelectedLegends(tempSelection);
  }, [titleColorsMap]);

  const handleSelectionChange = (name: string) => {
    setSelectedLegends({ ...selectedLegends, [name]: !selectedLegends[name] });
    onSelectionChange(name === NULL_VALUE_TITLE ? null : name);
  };

  return (
    <div id="legends-analytics-wrapper" className="flex flex-col gap-3 max-w-full">
      {Object.keys(titleColorsMap).map((legend, i) => (
        <div
          id={`legends-analytics-${i}`}
          key={`legend_${legend}`}
          className="flex max-w-full items-center"
          style={{ opacity: selectedLegends[legend] ? 1 : 0.3 }}
          onClick={() => handleSelectionChange(legend)}
        >
          <span
            id={`legends-analytics-${i}-background-color`}
            className="w-5 h-5 rounded-md shrink-0 mr-2"
            style={{ backgroundColor: `rgb(${titleColorsMap[legend]})` }}
          ></span>
          <span
            id={`legends-analytics-${i}-display`}
            className="text-base break-words leading-tight"
          >
            {legend ? legend : NULL_VALUE_TITLE}
          </span>
        </div>
      ))}
    </div>
  );
};
